import { getWindowOrigin } from "@/desktop/use-window-origin";
import { resolvePresentationRect } from "@/lib/agent-presentation-contract";
import type {
  AgentPresentation,
  AgentPresentationStep,
} from "@/lib/agent-presentation-types";

/** Numeric evidence joining screenshot resolution to the actual browser paint. */
export function presentationPaintGeometry(
  presentation: AgentPresentation,
  step: AgentPresentationStep,
  element: Element | null,
) {
  if (step.kind !== "highlight" && step.kind !== "draw") return undefined;
  const target = resolvePresentationRect(step, presentation);
  const origin = getWindowOrigin();
  if (!target || !element || !origin.ready) return undefined;
  const bounds = element.getBoundingClientRect();
  return {
    target: [target.x, target.y, target.width, target.height],
    windowOrigin: [origin.x, origin.y],
    viewport: [window.innerWidth, window.innerHeight],
    painted: [bounds.x, bounds.y, bounds.width, bounds.height],
  };
}
